
export default {
  
  drawer: null,
  color: 'orange-algebra',
  image: '/assets/images/logos/logo_portrait2_tall.png',
  languages: [
    { flag: "hr", language: "hr", title: "Hrvatski" },
    { flag: "us", language: "en", title: "English" }
  ],
  loginModal: true,
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.74)',


  currentUser: {
    FullName: ''
  },

  podruznice: [],

}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/app/app_state.js